import {
  Box,
  Divider,
  SvgIconProps,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";

const ElementGridDocument = ({
  title,
  description,
  Icon,
  divider,
  sx,
}: {
  title?: React.ReactNode;
  description?: React.ReactNode;
  Icon?: React.ComponentType<SvgIconProps>;
  divider?: boolean;
  sx?: SxProps<Theme>;
}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          ...sx,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Box display="flex" alignItems="center">
            {Icon && (
              <Icon color="action" sx={{ marginRight: 1, fontSize: "20px" }} />
            )}
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "14px",
                wordWrap: { sm: "break-word" },
                flex: { sx: 1 },
              }}
            >
              {title}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{
              wordWrap: "break-word",
              maxWidth: "100%",
              fontSize: "min(4vw, 14px)",
            }}
            align="right"
          >
            {description}
          </Typography>
        </Box>
      </Box>

      {divider && <Divider sx={{ my: "5px" }} />}
    </>
  );
};

export default ElementGridDocument;
